import {observer} from "mobx-react";
import {FormSelect, Chips} from "@vidazoo/ui-kit";
import theme from "../theme.module.scss";
import * as React from "react";
import {IChangeLogFilter} from "../../../common/interfaces/IChangeLogFilter";
import {FilterOperators} from '../../../../../common/enums/FilterOperators';
import useChangeLogsModel from '../../../common/hooks/useChangeLogsModel';

export interface IModelIdFilterProps extends React.InputHTMLAttributes<HTMLInputElement> {
    filter: IChangeLogFilter;
}

function ModelIdFilter({filter}: IModelIdFilterProps): React.JSX.Element {
    const model = useChangeLogsModel();

    const onChangeFilterParam = (e: { target: { name: any; value: any; }; }) => {
        const {name, value} = e.target;
        model.setFilterParam(filter, name, value);
    }

    const addFilterValue = (value: string) => {
        model.addFilterParamArray(filter, "value", value);
    }

    const onDeleteValue = (value: string, label: string) => {
        model.removeFilterParamArray(filter, "value", value);
    }

    return (
        <>
            <FormSelect
                className={theme.select}
                items={[FilterOperators.isAnyOf, FilterOperators.isNotAnyOf]}
                maxItems={5}
                itemValueKey="value"
                itemLabelKey="label"
                value={filter.operator || FilterOperators.isAnyOf}
                name="operator"
                required
                hideValidationMessage
                hideWhiteSpacesMessage={true}
                onChange={onChangeFilterParam}
                searchable
            />
            <Chips
                deepPurple
                allowOrder={false}
                leaveOpenAfterSelect
                allowCreate={true}
                selectValueOnBlur={false}
                chips={filter.value}
                onSelect={addFilterValue}
                onDelete={onDeleteValue}
            />
        </>
    );
}

export default observer(ModelIdFilter);
